"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryWithTimeout = exports.memoizedRetryWithTimeout = void 0;
var _retry = _interopRequireDefault(require("./retry"));
var _timeout = _interopRequireDefault(require("./timeout"));
var _globalMemoAsync = _interopRequireDefault(require("./globalMemoAsync"));
const retryWithTimeout = asyncAction => (0, _retry.default)({
  asyncAction: () => (0, _timeout.default)({
    asyncAction
  })
});
exports.retryWithTimeout = retryWithTimeout;
const memoizedRetryWithTimeout = (cacheName, inputs, wrappedFn) => (0, _globalMemoAsync.default)({
  globalObject: window,
  cacheName,
  inputs
})(() => retryWithTimeout(wrappedFn));
exports.memoizedRetryWithTimeout = memoizedRetryWithTimeout;